import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';

export interface LoanMapping {
  id: string;
  loanId: string;
  type: string;
  mapping: {
    target_folder: string;
    document_ids: string[];
  };
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
}

export interface GetLoanMappingsParams {
  loanId: string;
  type?: string;
}

export interface GetLoanMappingsResponse {
  success: boolean;
  loanMappings: LoanMapping[];
}

const getLoanMappings: QueryFunction<
  LoanMapping[],
  ['/loans', string, 'loan-mappings', string?]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockData);

  const loanId = queryKey[1];
  const type = queryKey[3];

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const baseUrl = `/loans/${loanId}/loan-mappings`;
  const url = type ? `${baseUrl}?type=${encodeURIComponent(type)}` : baseUrl;
  const response = await authTokenHttp<GetLoanMappingsResponse>(url, {
    method: 'GET',
  });

  if (response.data) {
    return response.data.loanMappings;
  }
  throw new Error('Failed to fetch loan mappings');
};

export default getLoanMappings;

const _mockData: LoanMapping[] = [
  {
    id: 'mock-1',
    loanId: 'loan-1',
    type: 'Export-Folder-Mappings',
    mapping: {
      target_folder: 'Assets - Bank Statements',
      document_ids: ['doc-1', 'doc-2'],
    },
    createdAt: '2025-01-01T00:00:00Z',
    updatedAt: '2025-01-01T00:00:00Z',
    isDeleted: false,
  },
];
